import React from 'react';
import {PeriodTable as PeriodTableModel} from '../types/ManagementOverviewReport.types';
import {
    formatManagementDecimal,
    formatManagementPercent,
} from '../utils/managementOverviewFormatters';
import ReportSectionTitle from './ReportSectionTitle';

interface PeriodTableProps {
    title?: string;
    table: PeriodTableModel;
    variant: 'monthly' | 'weekly';
    stationName: string;
    sectionAside?: React.ReactNode;
    hideSectionTitle?: boolean;
}

const PeriodTable: React.FC<PeriodTableProps> = ({
    title,
    table,
    variant,
    stationName,
    sectionAside,
    hideSectionTitle = false,
}) => {
    const stationHeader = `UFV\n${stationName}`;

    return (
        <section className="management-overview-period-table avoid-break">
            {title && !hideSectionTitle ? (
                <ReportSectionTitle aside={sectionAside}>{title}</ReportSectionTitle>
            ) : null}
            <table>
                <thead>
                    <tr>
                        <th scope="col" className="management-overview-period-table__station-col">
                            {stationHeader.split('\n').map((line, index) => (
                                <span key={`${line}-${index}`}>
                                    {line}
                                    {index === 0 ? <br /> : null}
                                </span>
                            ))}
                        </th>
                        <th scope="col">Energia<br />Gerada</th>
                        <th scope="col">Energia<br />Injetada</th>
                        <th scope="col">Energia<br />Esperada</th>
                        <th scope="col">Eficiência<br />%</th>
                        <th scope="col">Irradiação POA<br />(kWh/m²)</th>
                        <th scope="col">Irradiação GHI<br />(kWh/m²)</th>
                        <th scope="col">% PR<br />Básico</th>
                        <th scope="col">% PR<br />Normalizado</th>
                    </tr>
                </thead>
                <tbody>
                    {table.rows.map((row) => (
                        <tr key={`${variant}-${row.label}`}>
                            <th scope="row">{row.label}</th>
                            <td>{formatManagementDecimal(row.generatedEnergyMwh)}</td>
                            <td>{formatManagementDecimal(row.injectedEnergyMwh)}</td>
                            <td>{formatManagementDecimal(row.expectedEnergyMwh)}</td>
                            <td>{formatManagementPercent(row.efficiencyPercent)}</td>
                            <td>{formatManagementDecimal(row.irradiancePoaKwhM2)}</td>
                            <td>{formatManagementDecimal(row.irradianceGhiKwhM2)}</td>
                            <td>{formatManagementPercent(row.basicPrPercent)}</td>
                            <td>{formatManagementPercent(row.normalizedPrPercent)}</td>
                        </tr>
                    ))}
                    <tr className="management-overview-period-table__totals">
                        <th scope="row">Total</th>
                        <td>{formatManagementDecimal(table.totals.generatedEnergyMwh)}</td>
                        <td>{formatManagementDecimal(table.totals.injectedEnergyMwh)}</td>
                        <td>{formatManagementDecimal(table.totals.expectedEnergyMwh)}</td>
                        <td>{formatManagementPercent(table.totals.efficiencyPercent)}</td>
                        <td>{formatManagementDecimal(table.totals.irradiancePoaKwhM2)}</td>
                        <td>{formatManagementDecimal(table.totals.irradianceGhiKwhM2)}</td>
                        <td>{formatManagementPercent(table.totals.basicPrPercent)}</td>
                        <td>{formatManagementPercent(table.totals.normalizedPrPercent)}</td>
                    </tr>
                </tbody>
            </table>
        </section>
    );
};

export default PeriodTable;
